import { useTranslation } from "react-i18next";

export default function PerMateriaal() {
  const { t } = useTranslation("kozijn-reparatie");

  const images = [
    "/img/35-skilled-craftsman-hands-repairing.jpg",
    "/img/08-white-pvc-window-frame.jpg",
    "/img/36-sleek-aluminium-window-frame.jpg",
  ];

  const sections = [
    { key: "hout", img: images[0], alt: "Houten kozijn repareren met epoxy en professioneel gereedschap" },
    { key: "pvc", img: images[1], alt: "PVC kunststof kozijn reparatie met afdichtingen en scharnieren" },
    { key: "alu", img: images[2], alt: "Aluminium kozijn repareren thermische onderbreking en coating" },
  ];

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-6 md:mb-8">
          {t("perMateriaal.h2")}
        </h2>
        <p className="font-geist text-base md:text-lg text-brand-text/70 leading-relaxed text-center mb-10 md:mb-14 max-w-[800px] mx-auto">
          {t("perMateriaal.intro")}
        </p>

        <div className="flex flex-col gap-12 md:gap-16">
          {sections.map((sec, i) => {
            const h3 = t(`perMateriaal.${sec.key}.h3`);
            const p1 = t(`perMateriaal.${sec.key}.p1`);
            const p2 = t(`perMateriaal.${sec.key}.p2`);

            return (
              <div
                key={sec.key}
                className={`flex flex-col ${i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"} items-stretch gap-6 md:gap-10`}
              >
                <div className="flex-1 relative min-h-[260px] md:min-h-0 rounded-xl overflow-hidden">
                  <img
                    src={sec.img}
                    alt={sec.alt}
                    className="absolute inset-0 w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 flex flex-col justify-center">
                  <h3 className="font-geist font-bold text-xl md:text-2xl text-brand-text mb-3 md:mb-4">
                    {h3}
                  </h3>
                  <p className="font-geist text-sm md:text-base text-brand-text/70 leading-relaxed mb-3">
                    {p1}
                  </p>
                  <p className="font-geist text-sm md:text-base text-brand-text/70 leading-relaxed">
                    {p2}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}